// extracted by css-extract-rspack-plugin
export default {"hideMobile":"_7a3d1af8"};